<template>
    <div class="ag-cell-label-container" role="presentation">
        <div ref="eLabel" class="ag-header-cell-label" role="presentation"
             @click="changeSorting"
        >
            <el-tooltip placement="bottom"
                        :open-delay="500"
                        :disabled="!params.tooltip"
            >
                <span slot="content" v-html="params.tooltip"></span>
                <span ref="eText" class="ag-header-cell-text" role="columnheader"
                      v-html="params.column.colDef.headerName"
                ></span>
            </el-tooltip>
            <template v-if="params.enableSorting">
                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" :class="{'ag-hidden': sort !== 'asc'}" aria-hidden="true">
                    <i class="fa fa-sort-up"/>
                </span>
                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" :class="{'ag-hidden': sort !== 'desc'}" aria-hidden="true">
                    <i class="fa fa-sort-down"/>
                </span>
                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" :class="{'ag-hidden': sort}" aria-hidden="true">
                    <i class="fa fa-sort"/>
                </span>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            sort: null
        };
    },
    beforeMount() {
		this.sortChanged();

        if (this.params.enableSorting) {
            this.params.column.addEventListener('sortChanged', this.sortChanged);
        }
    },
    beforeDestroy() {
        if (this.params.enableSorting) {
            this.params.column.removeEventListener('sortChanged', this.sortChanged);
        }
    },
    methods: {
        changeSorting() {
            if (this.params.enableSorting) {
                this.params.progressSort();
            }
        },
        sortChanged() {
            this.sort = this.params.column.getSort();
        }
    }
};
</script>

<style lang="scss">
.ag_table .ag-header-cell.align-right .ag-header-cell-text {
	text-align: right;
}

.ag_table .ag-header-cell.break-spaces .ag-header-cell-text {
	white-space: break-spaces;
}
</style>